import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementLocale } from '@stripe/stripe-js';
import { JWTProvider } from 'contexts/JWTContext';
import ModalProvider from 'mui-modal-provider';
import { SnackbarProvider } from 'notistack';
import { useIntl } from 'react-intl';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useSelector } from 'react-redux';
// global style for resizer
import 'react-resizable/css/styles.css';
// routing
import Routes from 'routes';
// defaultTheme
import themes from 'themes';
// store
import { DefaultRootStateProps } from 'types';
// import RTLLayout from 'components/RTLLayout';
import Snackbar from 'views/components/extended/Snackbar';
// project imports
import Locales from 'views/components/Locales';
// auth provider
import NavigationScroll from 'views/layout/NavigationScroll';

// ==============================|| APP ||============================== //
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '');

const Components = () => {
  const intl = useIntl();

  return (
    <Elements stripe={stripePromise} options={{ locale: intl.locale as StripeElementLocale }}>
      <ModalProvider beta>
        <>
          <Routes />
          <Snackbar />
        </>
      </ModalProvider>
    </Elements>
  );
};

const App = () => {
  const customization = useSelector((state: DefaultRootStateProps) => state.customization);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        {/* RTL layout */}
        {/* <RTLLayout> */}
        <Locales>
          <SnackbarProvider>
            <NavigationScroll>
              <QueryClientProvider client={queryClient}>
                <JWTProvider>
                  <Components />
                </JWTProvider>
                {/* <ReactQueryDevtools /> */}
              </QueryClientProvider>
            </NavigationScroll>
          </SnackbarProvider>
        </Locales>
        {/* </RTLLayout> */}
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
